import axios from 'axios'

export const affiliate_api = {
	methods: {
		async get_adv_by_tag(name_tag) {
			let response = await axios.get('/api/auth/shopbytag', {
				params: { name_tag: name_tag },
			})

			return response
		},

		async get_aff_adv_list(login) {
			let response = await axios.get('/api/auth/affshoplist', {
				params: { email: login },
			})

			return response
		},

		async get_affiliate(login, password, flag_admin) {
			let response = await axios.get('/api/auth/aff', {
				params: {
					email: login,
					password,
					flag_admin,
				},
			})

			return response
		},

		async get_campaigns_active(aff_id, adv_id = null) {
			if (!aff_id) throw 'invalid affiliate'

			let response = await axios.get(`/api/affiliates/${aff_id}/campaigns/`, {
				auth: {
					username: localStorage.mgf_login,
					password: localStorage.mgf_password,
				},
				params: {
					adv: adv_id,
					validate_affiliate_active: true,
					active: true,
				},
			})

			return response
		},

		async get_campaigns(aff_id, adv_id = null) {
			if (!aff_id) throw 'invalid affiliate'

			let response = await axios.get(`/api/affiliates/${aff_id}/campaigns/`, {
				auth: {
					username: localStorage.mgf_login,
					password: localStorage.mgf_password,
				},
				params: {
					adv: adv_id,
				},
			})

			return response
		},

		async get_mgu_adv_list(mgu_id, categories = '') {
			if (!mgu_id) throw 'invalid affiliate'

			let response = await axios.get(`/api/affiliates/${mgu_id}/shop/`, {
				auth: {
					username: localStorage.mgf_login,
					password: localStorage.mgf_password,
				},
				params: {
					categories
				}
			})
			return response
		},

		async get_categories_list(params) {
			let response = await axios.get('/api/affiliates/categories', {
				auth: {
					username: localStorage.mgf_login,
					password: localStorage.mgf_password,
				},
				params: params,
			})

			return response
		},

		async get_mgu_adv_list_no_bond(mgu_id, category) {
			if (!mgu_id) throw 'invalid affiliate'

			let response = await axios.get(`/api/affiliates/${mgu_id}/shopnobond/`,
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
					params: {
						category,
					}
				}
			)
			return response
		},

		async bond_with_advertiser(mguId, advId) {
			if (!mguId) throw 'invalid magauser'
			if (!advId) throw 'invalid advertiser'

			let bondWithAdvertiser = await axios.post(
				`/api/affiliates/${mguId}/bond/${advId}`,
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
				})

			return bondWithAdvertiser
		},

		async send_email(mgu_id, dados) {
			if (!mgu_id) throw 'invalid magauser'

			let email_sent = await axios.post(
				`/api/affiliates/${mgu_id}/email/`,
				{
					templateParams: dados,
				},
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
				}
			)

			return email_sent
		},

		async get_notification(mgu_id) {
			if (!mgu_id) throw 'invalid magauser'

			let notification = await axios.get(
				`/api/affiliates/${mgu_id}/notification`,
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
				}
			)

			return notification
		},

		async patch_notification(mgu_id) {
			if (!mgu_id) throw 'invalid magauser'

			let notification_modified = await axios.patch(
				`/api/affiliates/${mgu_id}/notification`,
				{
					auth: {
						username: localStorage.getItem('mgf_login'),
						password: localStorage.getItem('mgf_password'),
					},
				}
			)

			return notification_modified
		},

		async get_guide_tour(mgu_id) {
			if (!mgu_id) throw 'invalid magauser'

			let tour = await axios.get(`/api/affiliates/${mgu_id}/tour`, {
				auth: {
					username: localStorage.mgf_login,
					password: localStorage.mgf_password,
				},
			})

			return tour.data
		},

		async patch_guide_tour(mgu_id, tour) {
			if (!mgu_id) throw 'invalid magauser'

			let guideTour = await axios.patch(
				`/api/affiliates/${mgu_id}/tour`,
				{
					guide_tour: tour,
				},
				{
					auth: {
						username: localStorage.getItem('mgf_login'),
						password: localStorage.getItem('mgf_password'),
					},
				}
			)

			return guideTour.data
		},

		async get_mgu_advertiser(mgu_id, adv_id) {
			if (!mgu_id) throw 'invalid magauser'
			if (!adv_id) throw 'invalid advertiser'
			let response = await axios.get(
				`/api/affiliates/${mgu_id}/shop/${adv_id}/affiliate/`,
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
				}
			)
			return response
		},

		async get_mgu_aff(mgu_id) {
			if (!mgu_id) throw 'invalid magauser'

			let response = await axios.get(`/api/affiliates/${mgu_id}/affiliate/`, {
				auth: {
					username: localStorage.mgf_login,
					password: localStorage.mgf_password,
				},
			})
			return response
		},

		async get_transactions(aff_id, params = {}) {
			if (!aff_id) throw 'invalid affiliate'
			let response = await axios.get(`/api/affiliates/${aff_id}/transactions`, {
				auth: {
					username: localStorage.mgf_login,
					password: localStorage.mgf_password,
				},
				params: params,
			})
			return response
		},

		async get_transactions_total(aff_id, params = {}) {
			if (!aff_id) throw 'invalid affiliate'
			let response = await axios.get(
				`/api/affiliates/${aff_id}/transactions/total`,
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
					params: params,
				}
			)
			return response
		},

		async get_commissions(aff_id, params) {
			if (!aff_id) throw 'invalid affiliate'

			let response = await axios.get(`/api/affiliates/${aff_id}/commissions`, {
				auth: {
					username: localStorage.mgf_login,
					password: localStorage.mgf_password,
				},
				params: params,
			})

			return response
		},

		async get_referral_link(aff_id, cmp_id) {
			if (!aff_id) throw 'invalid affiliate'
			if (!cmp_id) throw 'invalid campaign'

			let response = await axios.get(
				`/api/affiliates/${aff_id}/campaigns/${cmp_id}/link`,
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
				}
			)

			return response
		},

		async get_summary(aff_id, params = {}) {
			if (!aff_id) throw 'invalid affiliate'

			let response = await axios.get(`/api/affiliates/${aff_id}/summary`, {
				auth: {
					username: localStorage.mgf_login,
					password: localStorage.mgf_password,
				},
				params: params,
			})

			return response
		},

		// async get_actions(aff_id, adv_id, headers = {}) {
		// 	if (!aff_id) throw "invalid affiliate";
		// 	let response = await axios.get(`/api/affiliates/${aff_id}/actions/`, {
		// 		auth: {
		// 			username: localStorage.mgf_login,
		// 			password: localStorage.mgf_password,
		// 		},
		// 		params: {
		// 			adv: adv_id,
		// 		},
		// 		headers: headers,
		// 	});
		// 	return response;
		// },

		async get_actions(aff_id, page, headers = {}) {
			if (!aff_id) throw 'invalid affiliate'
			if (!page) throw 'invalid pagination'

			let response = await axios.get(`/api/affiliates/${aff_id}/actions_all/`, {
				auth: {
					username: localStorage.mgf_login,
					password: localStorage.mgf_password,
				},
				params: { page: page },
				headers: headers,
			})
			return response
		},

		async get_actions_filtered(aff_id, params = {}, headers = {}) {
			if (!aff_id) throw 'invalid affiliate'

			const queryParams = { page: 1, ...params }

			let response = await axios.get(`/api/affiliates/${aff_id}/actions_all/`, {
				auth: {
					username: localStorage.mgf_login,
					password: localStorage.mgf_password,
				},
				params: queryParams,
				headers: headers,

				paramsSerializer: params => {
					const searchParams = new URLSearchParams()
					Object.keys(params).forEach(key => {
						if (params[key] === undefined || params[key] === null) return

						if (Array.isArray(params[key])) {
							params[key].forEach(val => searchParams.append(key, val))
						} else {
							searchParams.append(key, params[key])
						}
					})
					return searchParams.toString()
				}
			})
			return response
		},

		async get_mktfile(aff_id, act_id, headers = {}) {
			if (!aff_id) throw 'invalid affiliate'
			if (!act_id) throw 'invalid action'

			let response = await axios.get(
				`/api/affiliates/${aff_id}/actions/${act_id}/mktfile`,
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
					headers: headers,
				}
			)

			return response
		},

		async get_forgot_password(email) {
			if (!email) throw 'invalid email of affiliate'

			let response = await axios.post('/api/affiliates/forgot_password', {
				email,
			})

			return response
		},

		async get_reset_password(email, token, password) {
			if (!email) throw 'invalid email of affiliate'
			if (!token) throw 'invalid token of affiliate'
			if (!password) throw 'invalid password of affiliate'

			let response = await axios.post('/api/affiliates/reset_password', {
				email,
				token,
				password,
			})

			return response
		},

		async get_create_affiliate(payload, loja = {}) {
			if (!payload) throw 'invalid dates of affiliate'

			let response = await axios.post('/api/affiliates/create_affiliado', {
				payload,
				loja,
			})

			return response
		},
		async get_dados_affiliate(magauser) {
			if (!magauser) throw 'invalid magauser of affiliate'

			const response = await axios.get(`/api/affiliates/${magauser}/afiliado`, {
				auth: {
					username: localStorage.mgf_login,
					password: localStorage.mgf_password,
				},
			})

			return response.data
		},
		async update_dados_affiliate(magauser, dados) {
			if (!magauser) throw 'invalid magauser of affiliate'

			const response = await axios.put(
				`/api/affiliates/${magauser}/afiliado`,
				{
					dados,
				},
				{
					auth: {
						username: localStorage.getItem('mgf_login'),
						password: localStorage.getItem('mgf_password'),
					},
				}
			)

			return response.data.msg
		},

		async get_upload_image1(magauser, image_formdata, params = {}) {
			if (!magauser) throw 'invalid magauser'
			if (!image_formdata) throw 'invalid formdata'

			let response = await axios.post(
				`/api/affiliates/${magauser}/afiliado/upload1`,
				image_formdata,
				{
					auth: {
						username: localStorage.getItem('mgf_login'),
						password: localStorage.getItem('mgf_password'),
					},
					params: params,
				}
			)

			return response
		},

		async get_upload_image2(magauser, image_formdata, params = {}) {
			if (!magauser) throw 'invalid magauser'
			if (!image_formdata) throw 'invalid formdata'

			let response = await axios.post(
				`/api/affiliates/${magauser}/afiliado/upload2`,
				image_formdata,
				{
					auth: {
						username: localStorage.getItem('mgf_login'),
						password: localStorage.getItem('mgf_password'),
					},
					params: params,
				}
			)

			return response
		},

		async post_email_notification(magauser, notification) {
			if (!magauser) throw 'invalid magauser'

			let response = await axios.post(
				`/api/affiliates/${magauser}/notification/email`,
				{
					notification,
				},
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
				}
			)

			return response
		},

		async get_email_notification(magauser) {
			if (!magauser) throw 'invalid magauser'

			let response = await axios.get(
				`/api/affiliates/${magauser}/notification/email`,
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
				}
			)

			return response
		},

		async post_shorted_link(url) {
			if (!url) throw 'invalid url'

			let response = await axios.post(
				'/api/affiliates/new/shortLink',
				{
					url
				},
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
				}
			)

			return response
		},

		async get_shorted_link(code) {
			if (!code) throw 'invalid url'

			let response = await axios.get(
				`/api/affiliates/stats/shortLink/${code}`,
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
				}
			)

			return response
		},

		async getAddressByCep(cep) {
			if (!cep) throw 'invalid cep'

			const { data } = await axios.get(`https://viacep.com.br/ws/${cep}/json`)

			return data
		},

		async generateLink(url, magauserId) {
			if (!url) throw 'invalid url'
			if (!magauserId) throw 'invalid Id do Magauser'

			let response = await axios.post(
				`/api/affiliates/generateLink/${magauserId}`,
				{
					domain: url
				},
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
				}
			)

			return response

		},
		async registrationAdvertiser(payload) {
			if (!payload) throw 'invalid payload'

			let response = await axios.post(
				'/api/affiliates/registration/advertiser',
				{
					payload
				},
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
				}
			)

			return response

		},

		async collect_datas_affiliate(payload) {
			if (!payload) throw 'invalid payload'

			let response = await axios.post(
				'/api/affiliates/collect/datas',
				{
					payload
				},
				{
					auth: {
						username: localStorage.mgf_login,
						password: localStorage.mgf_password,
					},
				}
			)

			return response
		},

		async validate_google_recaptcha(recaptchaToken) {
			if (!recaptchaToken) throw 'invalid payload'

			let response = await axios.post(
				'/api/affiliates/validate/recaptcha',
				{
					recaptchaToken
				}
			)

			return response
		}

	},
}

export default affiliate_api
